// removed by extract-text-webpack-plugin
module.exports = {"root":"app-pages-Login-__style___2z-qW","title":"app-pages-Login-__style___2nGvt","left":"app-pages-Login-__style___2WkBU","right":"app-pages-Login-__style___3Bp4v"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Login/style.css
// module id = 2198
// module chunks = 0